import React, { useState, useEffect } from "react";
import "./index.css";
import TreeNode from "./TreeNodeMapping";

const Tree = ({
  data = [],
  elementType,
  mapId,
  setMapId,
  mapValue,
  setMapValue,
  setMapType,
  showMapButton,
  setShowMapButton,
  setDataMapId,
  setParentObj,
  setUnmapJsonState,
  processVal,
  setProcessVal,
  mapBoundValue,
  setMapBoundValue,
  isWS,
  setUpdateList,
  setMapVariableType,
  setVarPrecision,
  setCurrentMappedElement,
  selectedVariableCallback = null,
  setVariableLength,
  currentMappedObject,
  setDataObjectType,
  setUnBounded,
  setSnackBarInfo,
  setAlertMsg,
  handleClose1,
  mappedContentForAdvance
}) => {
  // useEffect(() => {
  //   setDataObjectList(data);
  // }, []);
  // const [dataObjectList, setDataObjectList] = useState(data);

  return (
    <div className="d-tree">
      <ul className="d-flex d-tree-container flex-column">
        {data.map((tree) => (
          <>
            {elementType === "table" ||
            elementType === "doclist" ||
            elementType === "listview" ||
            elementType === "advancelistView" ||
            elementType === "advancelistview" ||
            elementType === "frame" ? (
              <>
                {(tree["Unbounded"] === "Y" ||
                  tree["Unbounded"] === "N" ||
                  tree["parentName"].length > 0) && (
                  <TreeNode
                    node={tree}
                    elementType={elementType}
                    mapId={mapId}
                    setCurrentMappedElement={setCurrentMappedElement}
                    isWS={isWS}
                    setMapId={setMapId}
                    mapValue={mapValue}
                    setMapValue={setMapValue}
                    setMapType={setMapType}
                    showMapButton={showMapButton}
                    setDataMapId={setDataMapId}
                    setShowMapButton={setShowMapButton}
                    setParentObj={setParentObj}
                    key={tree["VariableName"]}
                    setUnmapJsonState={setUnmapJsonState}
                    setUpdateList={setUpdateList}
                    processVal={processVal}
                    setProcessVal={setProcessVal}
                    mapBoundValue={mapBoundValue}
                    setMapBoundValue={setMapBoundValue}
                    setMapVariableType={setMapVariableType}
                    setVarPrecision={setVarPrecision}
                    setVariableLength={setVariableLength}
                    selectedVariableCallback={selectedVariableCallback}
                    currentMappedObject={currentMappedObject}
                    setDataObjectType={setDataObjectType}
                    setUnBounded={setUnBounded}
                    setSnackBarInfo={setSnackBarInfo}
                    setAlertMsg={setAlertMsg}
                    handleClose1={handleClose1}
                    mappedContentForAdvance={mappedContentForAdvance}
                  />
                )}
              </>
            ) : elementType === "textbox" ||
              elementType === "doclist" ||
              elementType === "textarea" ||
              elementType === "datepick" ||
              elementType === "slider" ||
              elementType === "checkbox" ||
              elementType === "toggle" ||
              elementType === "picklist" ||
              elementType === "listbox" ||
              elementType === "combo" ||
              elementType === "label" ||
              elementType === "link" ||
              elementType === "radio" ||
              elementType === "tile" ||
              elementType === "button" ? (
              <>
                {(tree["Unbounded"] === "N" || tree["Unbounded"] === "Y") && (
                  <TreeNode
                    node={tree}
                    elementType={elementType}
                    mapId={mapId}
                    isWS={isWS}
                    setCurrentMappedElement={setCurrentMappedElement}
                    setMapId={setMapId}
                    mapValue={mapValue}
                    setMapValue={setMapValue}
                    setMapType={setMapType}
                    showMapButton={showMapButton}
                    setShowMapButton={setShowMapButton}
                    key={tree["VariableName"]}
                    setUnmapJsonState={setUnmapJsonState}
                    setDataMapId={setDataMapId}
                    setParentObj={setParentObj}
                    processVal={processVal}
                    setProcessVal={setProcessVal}
                    mapBoundValue={mapBoundValue}
                    setMapBoundValue={setMapBoundValue}
                    setUpdateList={setUpdateList}
                    setMapVariableType={setMapVariableType}
                    setVarPrecision={setVarPrecision}
                    setVariableLength={setVariableLength}
                    selectedVariableCallback={selectedVariableCallback}
                    currentMappedObject={currentMappedObject}
                    setDataObjectType={setDataObjectType}
                    setUnBounded={setUnBounded}
                    setSnackBarInfo={setSnackBarInfo}
                    setAlertMsg={setAlertMsg}
                    handleClose1={handleClose1}
                    mappedContentForAdvance={mappedContentForAdvance}
                  />
                )}
              </>
            ) : (
              <></>
            )}
          </>
        ))}
      </ul>
    </div>
  );
};

export default Tree;
